import {objectAssign, serializeParam, uuid} from '@tencent/midas-util';
import logdata from './logdata'

/**
 * 文档说明
 * http://tapd.oa.com/pay/wikis/view/web%2525E5%252589%25258D%2525E7%2525AB%2525AF%2525E6%2525B5%25258B%2525E9%252580%25259F%2525E4%2525B8%25258A%2525E6%25258A%2525A5%2525E8%2525A7%252584%2525E8%25258C%252583
 * @param opt.iformat
 * @param opt.webversion
 * @param opt.sessionToken
 * @param opt.times
 * @param opt.resourceTiming
 * @param opt.customTiming
 * @param opt.customTimes
 * @param opt.logdataParams
 */

export default function(opt){
	setTimeout(function(){
		_midasPerformanceReport(opt)
	})
}

function _midasPerformanceReport(opt){
	var resultInfo = {};
	
	if(opt.times === undefined){
		throw new Error('需要上报首屏时间times');
	}
	
	resultInfo.times = opt.times;
	
	//先收集performance.timing信息
	var keys =  ["navigationStart", "unloadEventStart", "unloadEventEnd", "redirectStart", "redirectEnd", "fetchStart", "domainLookupStart", "domainLookupEnd", "connectStart", "connectEnd", "secureConnectionStart", "requestStart", "responseStart", "responseEnd", "domLoading", "domInteractive", "domContentLoadedEventStart", "domContentLoadedEventEnd", "domComplete", "loadEventStart", "loadEventEnd"];
	var _p = window.webkitPerformance || window.performance;
	var _t = _p && _p.timing;
	if(_t){
	    for (var i = 0, l = keys.length; i < l; ++i) {
	    	var key = keys[i];
	    	if(_t[key] !== undefined){
	    		resultInfo[key] = Math.round(_t[key]) || 0
	    	}
	    }
	}
	
	//先采集时间点
	var resourceKeys = ['startTime', 'redirectStart', 'redirectEnd', 'fetchStart', 'domainLookupStart', 'domainLookupEnd', 'connectStart', 'secureConnectionStart', 'connectEnd', 'requestStart', 'responseStart', 'responseEnd', 'duration'];
	//收集resourceTiming信息
	if(opt.resourceTiming){
		for(var entryName in opt.resourceTiming){
			var entry = opt.resourceTiming[entryName];
			if(entry){
				var res = {};
				for (var i = 0, l = resourceKeys.length; i < l; ++i) {
			    	var key = resourceKeys[i];
			    	if(entry[key] !== undefined){
			    		res[key] = Math.round(entry[key]) || 0
			    	}
			    }
			    resultInfo['entry_' + entryName] = serializeParam(res, true)
			}
		}
	}
	
	//自定义的时间点
	if(opt.customTiming){
		for(var customKey in opt.customTiming){
			if(typeof opt.customTiming[customKey] === 'number'){
				resultInfo['timing_' + customKey] = opt.customTiming[customKey]
			}
		}
	}
	
	//自定义的时间段
	if(opt.customTimes){
		for(var customKey in opt.customTimes){
			if(typeof opt.customTimes[customKey] === 'number'){
				resultInfo['times_' + customKey] = opt.customTimes[customKey]
			}
		}
	}
	
	logdata(objectAssign({}, opt.logdataParams || {}, {
		8 : resultInfo,
		21 : opt.iformat,
		29 : opt.sessionToken || (uuid() + new Date().getTime()),
		31 : opt.webversion
	}))
}